/* Priority Delivery add-on — Wool Life (v2)
   Syncs hidden "Priority Delivery" product qty to number of real items in cart. */
(function () {
  var PRIORITY_VARIANT_ID = 43249148035133;
  var isSyncing = false;
  var syncTimer = null;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function priorityItem(cart) {
    return cart.items.find(function (i) { return i.variant_id === PRIORITY_VARIANT_ID; });
  }

  function realItemCount(cart) {
    return cart.items.reduce(function (n, i) {
      return i.variant_id === PRIORITY_VARIANT_ID ? n : n + i.quantity;
    }, 0);
  }

  function setPriorityQty(qty, hasExisting) {
    isSyncing = true;
    var req;
    if (hasExisting) {
      req = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(PRIORITY_VARIANT_ID), quantity: qty })
      });
    } else if (qty > 0) {
      req = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: PRIORITY_VARIANT_ID, quantity: qty })
      });
    } else {
      req = Promise.resolve();
    }
    return req.finally(function () { isSyncing = false; });
  }

  function refreshUI() {
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        if (sections['cart-drawer']) {
          var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var oldDrawer = document.querySelector('cart-drawer');
          var newDrawer = newDoc.querySelector('cart-drawer');
          if (oldDrawer && newDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
        }
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var newBubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = newBubbleDoc.getElementById('cart-icon-bubble');
          if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
        }
        hidePriorityControls();
      })
      .catch(function () {});
  }

  /* Debounced: many triggers can fire for one user action */
  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncIfNeeded, delay || 300);
  }

  function syncIfNeeded() {
    if (isSyncing) { scheduleSync(400); return; }
    return getCart().then(function (cart) {
      var p = priorityItem(cart);
      if (!p) { hidePriorityControls(); return; }
      var target = realItemCount(cart);
      if (p.quantity !== target) {
        return setPriorityQty(target, true).then(refreshUI);
      }
      hidePriorityControls();
    });
  }

  /* ---- Trigger 1: the checkbox itself ---- */
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-priority-checkbox]');
    if (box) {
      box.disabled = true;
      getCart().then(function (cart) {
        var p = priorityItem(cart);
        return setPriorityQty(box.checked ? realItemCount(cart) : 0, !!p);
      }).then(refreshUI);
      return;
    }
    /* ---- Trigger 2: any quantity input change (cart page + drawer) ---- */
    if (e.target.closest('quantity-input') || e.target.name === 'updates[]') {
      scheduleSync(800); /* give the theme time to finish its own update */
    }
  }, true);

  /* ---- Trigger 3: remove buttons ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('cart-remove-button, .cart-remove-button, a[href*="/cart/change"]')) {
      scheduleSync(800);
    }
  }, true);

  /* ---- Trigger 4: Dawn's pub/sub cart-update event (the proper hook) ---- */
  function trySubscribe() {
    if (typeof window.subscribe === 'function' &&
        window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        if (!isSyncing) scheduleSync(150);
      });
      return true;
    }
    return false;
  }

  /* ---- Trigger 5: intercept theme's cart fetches (backstop) ---- */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var isCartMutation = /\/cart\/(add|change|update)/.test(url);
    var result = origFetch.apply(this, arguments);
    if (isCartMutation && !isSyncing) {
      result.then(function () { scheduleSync(150); }).catch(function () {});
    }
    return result;
  };

  function hidePriorityControls() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var isPriority = row.querySelector('a[href*="priority-delivery"]') ||
        (row.querySelector('.cart-item__name') &&
         row.querySelector('.cart-item__name').textContent.indexOf('Priority Delivery') !== -1);
      if (isPriority) {
        row.querySelectorAll('quantity-input, cart-remove-button').forEach(function (el) {
          el.style.display = 'none';
        });
      }
    });
  }

  function init() {
    if (!trySubscribe()) {
      /* pubsub may load after us — retry briefly */
      var tries = 0;
      var iv = setInterval(function () {
        if (trySubscribe() || ++tries > 20) clearInterval(iv);
      }, 250);
    }
    hidePriorityControls();
    syncIfNeeded(); /* heals stale qty on every load */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Heals when returning from checkout via the back button (page restored from cache) */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) syncIfNeeded();
  });
})();